import React from 'react';

import { useForm } from 'react-hook-form';

import { LbInput, LbSelect } from '@infoods/lifebase-ui';

import classes from './VideoFormModal.module.scss';
import { LbModal } from '../../../../shared/components/modals';

import { LbCheckbox } from '../../../../shared/components/form-components';
import { Option } from '../../../../general-types';
import { VideoFormValues } from '../../../interface/video';

type AddVideoModalProps = {
  title: string;
  video?: VideoFormValues;
  categoryOptions: Option<string>[];
  onClose: () => void;
  onSubmit: (video: VideoFormValues) => void;
};

const VideoFormModal = ({
  title,
  video,
  categoryOptions,
  onClose,
  onSubmit,
}: AddVideoModalProps) => {
  const { control, handleSubmit } = useForm<VideoFormValues>({
    defaultValues: video,
  });

  const defaultInputProps = {
    control,
    variant: 'standard',
    size: 'medium',
  } as const;

  const handleFormSubmit = handleSubmit((data: VideoFormValues) => {
    onSubmit(data);
    onClose();
  });

  return (
    <LbModal
      open
      title={title}
      primaryBtnConfig={{ text: 'Confirm', onClick: handleFormSubmit }}
      secondaryBtnConfig={{ text: 'Cancel', onClick: onClose }}
    >
      <div className={classes.container}>
        <LbInput
          {...defaultInputProps}
          label="Video name"
          name="title"
          rules={{ required: 'Video name is required' }}
        />
        <LbSelect
          {...defaultInputProps}
          label="Category"
          name="category"
          options={categoryOptions}
          rules={{ required: 'Category is required' }}
        />
        <LbInput
          {...defaultInputProps}
          label="Link"
          name="youtubevideo"
          rules={{
            required: 'Video link is required',
            pattern: {
              value: /^(https?:\/\/)?(((www\.)?|(m.)?)youtube\.com|youtu\.?be)\/.+$/,
              message: 'Invalid video link (must be a youtube link)',
            },
          }}
        />
        <LbCheckbox
          control={control}
          name="isDisplayed"
          label="Display after 1st login"
          color="primary"
        />
      </div>
    </LbModal>
  );
};

export { VideoFormModal };
